import RegisterFuture from './register-future-container';

export default RegisterFuture;
